import React from 'react'
import { TenantInformation } from './components/TenantInformation'

function Profile() {
  return (
    <div className=' flex gap-4'>
      <div className='w-2/1 pr-8'>
        <TenantInformation />
      </div>
    </div>
  )
}

export { Profile }
